import React from 'react'
import PropTypes from 'prop-types'

import { i18n } from 'parking-react-common'

const SidebarMenu = ({ title, children }) => (
    <ul className="sidebar-elements">
        <li className="divider">
            { title }
        </li>
        { children }
    </ul>
)

SidebarMenu.propTypes = {
    title: PropTypes.string
}

SidebarMenu.defaultProps = {
    title: i18n.t('Menu')
}

export default SidebarMenu
